import { RouteConfig } from "vue-router";

export const RExpertTemplateDashboard: RouteConfig = {
  path: "dashboard/:tabTypeId(\\d+)",
  name: "employerDashboard",
  component: () =>
    import(
      /* webpackChunkName: "expert-template-dashboard" */
      "./VTemplateDashboard.vue"
    ),
  meta: {
    label: "dashboard",
    tabName: "dashboard",
  },
};

export const RCandidateTemplateDashboard: RouteConfig = {
  path: "dashboard/:tabTypeId(\\d+)",
  name: "candidateDashboard",
  component: () =>
    import(
      /* webpackChunkName: "candidate-template-dashboard" */
      "./VTemplateDashboard.vue"
    ),
  meta: {
    label: "dashboard",
    tabName: "dashboard",
  },
};
